import script from "./ValidatedMultiselect.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidatedMultiselect.vue?vue&type=script&setup=true&lang=js"

import "./ValidatedMultiselect.vue?vue&type=style&index=0&id=65c22176&lang=less"

const __exports__ = script;

export default __exports__